import { JsonProperty, JsonObject } from "json2typescript";

@JsonObject("ProposalTrendItem")
export class ProposalTrendItem {
    @JsonProperty("year",Number)
    public year: number = 0;

    @JsonProperty("pi_amount",Number)
    public pi_amount: number = 0;
    
    @JsonProperty("co_pi_amount",Number)
    public co_pi_amount: number = 0;

    @JsonProperty("other_amount",Number)
    public other_amount: number = 0;
    
    @JsonProperty("total_amount",Number)    
    public total_amount: number = 0;
    
    @JsonProperty("pi_count",Number)
    public pi_count: number = 0;

    @JsonProperty("co_pi_count",Number)
    public co_pi_count: number = 0;

    @JsonProperty("other_count",Number)
    public other_count: number = 0;

    @JsonProperty("total_count",Number)    
    public total_count: number = 0;

}


// WEBPACK FOOTER //
// ./src/models/ProposalTrendItem.ts